import {
    ISlideComponent,
    ISlideEditLogic,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/types';
import {
    IEditorInstanceService,
} from '@src/slide/application/service/editor-instance-service/editor-instance-service.interface';
import { TextEditor } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor';

export class SlideEditLogic implements ISlideEditLogic {
    private slideComponent: ISlideComponent;

    public constructor(private editorInstanceService: IEditorInstanceService) {
    }

    public dispose(): void {
    }

    public setComponent(component: ISlideComponent): void {
        this.slideComponent = component;
    }

    public onDidRender() {
        this.updateEditorSurface();
    }

    /**
     * 如果在编辑态的话，触发下光标位置的检查和更新
     */
    private updateEditorSurface() {
        const textEditor = this.editorInstanceService.getEditorInstance();
        if (textEditor instanceof TextEditor && textEditor?.isEditing) {
            textEditor?.ifUpdateEditorSurface();
        }
    }
}
